import { Dropdown, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { AiOutlineExpandAlt } from 'react-icons/ai';
import { useMainContext } from '../../../hooks/useMainContext';
import { DeleteIconSm, EditIcon } from '../../Globle/Icon';
import DeleteModel from '../../Globle/DeleteModel';

const UnitList = observer(() => {
    const { viewManager, closetManager, drawingManager } = useMainContext();
    const [isOpen, setIsOpen] = useState(false);
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const isVisible = viewManager.doUserHasAccess();

    const handleDelete = (unit) => {
        if (drawingManager.isDrawingModeOn) {
            message.error("Can't do this operation while drawing mode is on.");
            return;
        }
        setIsModelOpen(true);
        setSelectedUnit(unit);
    };
    const handleCancel = () => {
        setIsModelOpen(false);
        setSelectedUnit(null);
    };
    const handleConfirmDelete = () => {
        if (viewManager.matrixCalculation) return;
        closetManager.removeUnitById(selectedUnit._id);
        handleCancel();
    };
    const handleFitToScreen = async (unitId) => {
        await closetManager.showUnits(unitId);
    };

    const handleEdit = (unit) => {
        if (viewManager.matrixCalculation) return;
        closetManager.setSelectedUnit(unit);
        viewManager.setUnitForm(true);
    };

    const renderMenu = () => {
        return (
            <div className="p-[8px] bg-theme-white w-[200px] shadow-card rounded-[8px]">
                <div className="flex flex-col gap-[4px] max-h-[340px] pr-[4px] overflow-y-auto">
                    {closetManager?.units?.length > 0 ? (
                        [...closetManager.units].map((unit, index) => (
                            <div
                                key={unit._id || index}
                                className="bg-transparent group rounded-[8px] p-[8px] cursor-pointer transition-all duration-300 ease-in-out flex items-center justify-between hover:bg-[#9CA3AF66]">
                                <span className="text-[14px] font-favorit font-[400] leading-[21px]">
                                    {unit._name || `Unit ${index + 1}`}
                                </span>
                                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out flex gap-[4px] items-center">
                                    <div
                                        className="cursor-pointer"
                                        onClick={() =>
                                            handleFitToScreen(unit._id)
                                        }>
                                        <AiOutlineExpandAlt className="text-[20px]" />
                                    </div>
                                    {isVisible && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleEdit(unit);
                                            }}>
                                            <EditIcon />
                                        </div>
                                    )}
                                    {isVisible && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => handleDelete(unit)}>
                                            <DeleteIconSm />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <span className="text-[14px] font-favorit leading-[21px] text-center">
                            No units available
                        </span>
                    )}
                </div>
            </div>
        );
    };
    return (
        <>
            <Dropdown
                className="ml-2"
                open={isOpen}
                onOpenChange={setIsOpen}
                placement="top"
                dropdownRender={renderMenu}
                disabled
                trigger={['click']}>
                <div className="flex items-center gap-[8px] ">
                    <span
                        className={`text-[16px] font-favorit ${isOpen ? 'font-[700]' : ''}`}>
                        Units
                    </span>
                    <span
                        className={`inline-block w-[24px] h-[24px] text-[12px] pt-[2px] pr-[2px] rounded-full ${isOpen ? 'bg-theme-orange' : 'bg-theme-stroke'} text-theme-white flex items-center justify-center`}>
                        {closetManager?.units?.length || 0}
                    </span>
                    {/* {isOpen ? (
                        <IoIosArrowUp size={20} />
                    ) : (
                        <IoIosArrowDown size={20} />
                    )} */}
                </div>
            </Dropdown>
            <DeleteModel
                isOpen={isModelOpen}
                onClose={() => {
                    handleCancel();
                }}
                name={selectedUnit?.name}
                onConfirm={() => handleConfirmDelete()}
            />
        </>
    );
});

export default UnitList;
